var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"h-100",attrs:{"id":"app"}},[(_vm.showMenu())?_c('base-sidebar'):_vm._e(),_c('base-header',{class:{ 'menu-margin': _vm.showMenu() }}),_c('div',{staticClass:"h-100"},[_c('b-container',{staticClass:"overflow-auto app-container",attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }